import "./App.css";
import Main from "./Components/Main/Main";
import RightSide from "./Components/RightSide";

function App() {
  return (
    <section className="col px-4">
      <div className="row mx-0">
        <RightSide />
        <Main/>
      </div>
    </section>
  );
}

export default App;
